// extracted by mini-css-extract-plugin
export default {"container":"style_container__xMkqp","configWrapper":"style_configWrapper__Ck6LU","config":"style_config__War-x","header":"style_header__MAeY4","content":"style_content__SnoMM"};